import { render } from "./radioField2.vue?vue&type=template&id=07338445"
import script from "./radioField2.vue?vue&type=script&lang=js"
export * from "./radioField2.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__